import { useNavigate } from "react-router-dom";

const EventV2PageHead = (props) => {
  const navigate = useNavigate();

  const goBack = () => {
    if (
      typeof props.BackAction === "string" &&
      /^https?:\/\//i.test(props.BackAction)
    ) {
      window.location.href = props.BackAction;
      return;
    }
    if (typeof props.BackAction === "number") {
      navigate(props.BackAction);
    } else if (props.BackAction) {
      navigate(props.BackAction);
    } else {
      navigate(-1);
    }
  };

  const headClassName = ["event-main-head", props.HeadClassName]
    .filter(Boolean)
    .join(" ");
  const titleClassName = props.TitleClassName || "event-main-title";
  const hasBack =
    props.BackAction !== undefined &&
    props.BackAction !== null &&
    props.BackAction !== false;
  const isCreateHead =
    props.CreateHead ||
    (props.HeadClassName && props.HeadClassName.includes("event-create-head"));
  const isDetailsLayout =
    props.DetailsHead ||
    (props.HeadClassName &&
      /(event-details-head|event-order-detail-head|event-earning-detail-head|event-earning-attendees-head|event-ticket-detail-head|event-attendee-detail-head|event-tickets-head|event-checkout-head|event-attendee-head)/.test(
        props.HeadClassName
      ));
  const isMarkedTitle = Boolean(props.TitleMarkClassName);

  const renderTitleContent = () => {
    if (
      props.TitleMarkClassName &&
      typeof props.Heading === "string" &&
      props.TitleMark != null
    ) {
      if (props.TitleMark === true) {
        return (
          <span className={props.TitleMarkClassName}>{props.Heading}</span>
        );
      }
      const mark = String(props.TitleMark);
      if (props.Heading.startsWith(mark)) {
        return (
          <>
            <span className={props.TitleMarkClassName}>{mark}</span>
            {props.Heading.slice(mark.length)}
          </>
        );
      }
    }
    return props.Heading;
  };

  const titleEl = props.hideTitle ? null : (
    <h1 className={titleClassName}>{renderTitleContent()}</h1>
  );

  const backBtn = hasBack ? (
    <button
      type="button"
      className="event-details-back-btn"
      onClick={goBack}
      aria-label="Go back"
    >
      <i className="bi bi-arrow-left" aria-hidden="true"></i>
    </button>
  ) : null;

  const actionButtons =
    !props.extraElement &&
    (props.ButtonHeading || props.SecondaryButtonHeading) ? (
      <div className="event-main-actions">
        {props.ButtonHeading && (
          <button
            className="event-action-btn"
            type="button"
            onClick={props.ButtonAction}
          >
            <i
              className={`bi ${props.ButtonIcon || "bi-funnel"}`}
              aria-hidden="true"
            ></i>
            <span>{props.ButtonHeading}</span>
          </button>
        )}
        {props.SecondaryButtonHeading && (
          <button
            className="event-action-btn is-primary"
            type="button"
            onClick={props.SecondaryButtonAction}
          >
            <i
              className={`bi ${props.SecondaryButtonIcon || "bi-calendar-plus"}`}
              aria-hidden="true"
            ></i>
            <span>{props.SecondaryButtonHeading}</span>
          </button>
        )}
      </div>
    ) : null;

  // Create-flow header (Basic Info, Tickets, Assign Guard, Attendees, etc.)
  if (isCreateHead) {
    return (
      <header className={headClassName}>
        <div className={props.LeftClassName || "event-create-head-left"}>
          {backBtn}
          {titleEl}
        </div>
        {props.extraElement}
        {actionButtons}
      </header>
    );
  }

  // Detail-style header with back + optional marked title
  if (isDetailsLayout || (hasBack && isMarkedTitle)) {
    const leftClass =
      props.LeftClassName ||
      (props.SubHeading && !props.HeadLabel
        ? "event-tickets-head-left"
        : "event-details-head-left");

    return (
      <header className={headClassName}>
        <div className={leftClass}>
          {backBtn}
          {props.HeadLabel ? (
            <div className="event-details-head-copy">
              <div className="event-details-head-meta">
                {props.HeadChip && (
                  <span className="event-chip">{props.HeadChip}</span>
                )}
                <span className="event-details-head-label">{props.HeadLabel}</span>
              </div>
              {titleEl}
              {props.SubHeading && (
                <p className="event-main-sub">{props.SubHeading}</p>
              )}
            </div>
          ) : props.SubHeading ? (
            <div className="event-tickets-head-copy">
              {titleEl}
              <p className="event-tickets-date">{props.SubHeading}</p>
            </div>
          ) : (
            titleEl
          )}
        </div>
        {props.extraElement}
        {actionButtons}
      </header>
    );
  }

  // Marked title pages (My Events, Orders, Wishlist, Promo, Earnings, Promoting)
  if (isMarkedTitle) {
    if (props.hideTitle && !props.extraElement && !actionButtons) {
      return null;
    }
    return (
      <header
        className={`${headClassName}${
          props.hideTitle ? " event-main-head--actions-only" : ""
        }`}
      >
        {titleEl}
        {props.extraElement}
        {actionButtons}
      </header>
    );
  }

  // Default head (All Events, My Created Events, etc.)
  if (props.hideTitle && !props.extraElement && !actionButtons && !hasBack) {
    return null;
  }
  return (
    <header
      className={`${headClassName}${
        props.hideTitle ? " event-main-head--actions-only" : ""
      }`}
    >
      <div className="event-main-head-copy">
        {backBtn}
        {titleEl}
        {props.SubHeading && (
          <p className="event-main-sub">{props.SubHeading}</p>
        )}
      </div>
      {props.extraElement || actionButtons}
    </header>
  );
};

export default EventV2PageHead;
